import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "jqwndp5n",
  dataset: "production",
  useCdn: true,
  apiVersion: "2024-03-06",
});
